import 'pannellum/build/pannellum.js';

export const panorama = (swiperInstance) => {
    const slides = swiperInstance.slides;
    let activeViewer = null;

    const makeGuard = (container) => {
        const guard = document.createElement('div');
        guard.className = 'viewer-guard';
        guard.innerHTML = '<span class="viewer-guard__hint">Нажмите, чтобы вращать панораму</span>';
        container.appendChild(guard);

        const activate = () => {
            guard.style.display = 'none';
            container.classList.add('viewer--active');
        };

        const deactivate = () => {
            guard.style.display = '';
            container.classList.remove('viewer--active');
        };

        guard.addEventListener('click', activate, {passive: true});
        guard.addEventListener('touchstart', activate, {passive: true});

        container.addEventListener('mouseleave', deactivate);
        window.addEventListener('scroll', deactivate, {passive: true});

        return {guard, activate, deactivate};
    };

    const initPanorama = (index) => {
        const slide = slides[index];
        if (!slide) return;

        const container = slide.querySelector('.main-3d__viewer');
        if (!container) return;

        const panoSrc = container.dataset.panorama;
        if (!panoSrc) return;

        activeViewer = window.pannellum.viewer(container, {
            type: 'equirectangular',
            panorama: panoSrc,
            autoLoad: true,
            showZoomCtrl: true,
            compass: false,
            keyboardZoom: false,
            draggable: true,
            mouseZoom: true,
            yaw: 0,
            pitch: 0,
            hfov: 100,
            minYaw: -180, maxYaw: 180,
            minPitch: -90, maxPitch: 90,
        });

        makeGuard(container);
    };

    const destroyPanorama = () => {
        if (activeViewer) {
            try {
                activeViewer.destroy();
            } catch {
            }
            activeViewer = null;
        }
        Array.from(slides).forEach((slide) => {
            const container = slide.querySelector('.main-3d__viewer');
            if (container) container.innerHTML = '';
        });
    };

    initPanorama(swiperInstance.activeIndex);

    swiperInstance.on('slideChange', () => {
        destroyPanorama();
        initPanorama(swiperInstance.activeIndex);
    });
};
